// @ts-nocheck
import { Component, booleanAttribute, computed, input, output } from '@angular/core';
import { v7 } from 'uuid';

@Component({
	selector: 'lbca-input-switch',
	templateUrl: './input-switch.component.html',
	styleUrl: './input-switch.component.scss',
})
export class InputSwitchComponent {
	public readonly value = input<string | boolean>();
	public readonly label = input<string | undefined>('');
	public readonly id = input<string | undefined>();
	public readonly color = input<string>('primary');
	public readonly checked = input<boolean, unknown>(false, {
		transform: booleanAttribute,
	});
	public readonly spaceJustify = input<boolean, unknown>(false, {
		transform: booleanAttribute,
	});

	public readonly changeValue = output<unknown>();

	public switchId = computed(() => {
		const inputId = this.id();
		if (inputId) {
			return inputId;
		}
		return this._generateIdentifier();
	});

	public classes = computed(() => {
		const alignClass = this.label() ? 'justify-between' : 'justify-end';
		return [alignClass];
	});

	private _generateIdentifier(): string {
		const uuid = v7();
		const label = this.label();

		if (label) {
			return `${label.replace(/[^a-zA-Z0-9]/g, '')}${uuid}`;
		}

		return uuid.toString();
	}

	onChange($event: any) {
		this.changeValue.emit({
			checked: $event.target.checked,
			value: this.value(),
		});
	}
}
